export enum ServiceEndpoints {
    uploadDeliveryNoteBundled = '/organization-sites/:organizationSiteKey/consignor/delivery-note-bundles/:deliveryNoteBundleKey/delivery-notes/pdf',
    uploadDeliveryNote = '/organization-sites/:organizationSiteKey/consignor/delivery-notes',
}
